import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const Materials = ({ materials, product }) => (materials && materials.length ? (
  <ProductPropertyTab title="Material / Ingredients / Care" product={product}>
    <PropertyList element="ul" like="dec-4">
      {
          materials.map((item) =>
            // eslint-disable-next-line react/no-danger
            <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
        }
    </PropertyList>
  </ProductPropertyTab>
) : null);

Materials.defaultProps = {
  materials: []
};

Materials.propTypes = {
  product: PropTypes.object.isRequired,
  materials: PropTypes.array
};

export default Materials;
